"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBER_FIELD_SUFFIX_MAX_LENGTH = exports.NUMBER_FIELD_PREFIX_MAX_LENGTH = exports.maxWholeDigits = exports.MAX_PRECISION = void 0;
exports.MAX_PRECISION = 6;
exports.maxWholeDigits = 16;
exports.NUMBER_FIELD_PREFIX_MAX_LENGTH = 20;
exports.NUMBER_FIELD_SUFFIX_MAX_LENGTH = 20;
